<app-mission-edit *ngIf="templates"
    [templates]="templates"
    (editFinished)="onLeave()"></app-mission-edit>
